import React, { useEffect, useState } from 'react';
import Header from './gapsy-header';
import Navigation from './gapsy-Anavigation';
import Footer from './gapsy-footer';
import "bootstrap/dist/css/bootstrap.min.css"
import 'bootstrap-icons/font/bootstrap-icons.css';
import styles from '../assets/css/gapsy-dashboard.module.css';
import tabStyles from '../assets/css/gapsy-tabs.module.css';
import { closeButtonStyle, Saveandadduser } from "../components/Propertyfile";
import { List_Checker, RoleandMapping, createTextFileApi, mappingdata, OwnershipApi, userinfo, ListAllusers } from "../components/ApiProperty";
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import formStyles from '../assets/css/gapsy-form.module.css';
import { Modal, Button } from 'react-bootstrap';

const GapsyUserMapping = () => {
    const [filteredUsers, setFilteredUsers] = useState([]);
    const navigate = useNavigate();
    const [showModalLdap, setShowModalLdap] = useState(false);
    const [editIndex, setEditIndex] = useState(null);
    const [checkerData, setCheckerData] = useState(null);
    const [showAllowUploadPopup, setShowAllowUploadPopup] = useState(false);
    const [pendingPayload, setPendingPayload] = useState(null); // store request for retry
    const [modalMessage3, setModalMessage3] = useState('');
    const [message, setMessage] = useState("");
    const [modalMessage, setModalMessage] = useState('');
    const [messageType, setMessageType] = useState(''); // 'success', 'warning', or 'error'
    const [disableInputs, setDisableInputs] = useState(false);
    const [passwordGenerated, setPasswordGenerated] = useState(false);
    const [selectedLocationValues, setSelectedLocationValues] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [departments, setDepartments] = useState([]); // Initialize as empty array
    const [selectedDepartments, setSelectedDepartments] = useState([]);
    const [users, setUsers] = useState([]);
    const [formData, setFormData] = useState({
        searchUserId: "",
        userFirstName: ""
    });
    const [initialData, setInitialData] = useState({});
    const [selectedRole, setSelectedRole] = useState('');
    const [hierarchy, setHierarchy] = useState('');
    const [sortConfig, setSortConfig] = useState({ key: 'userId', direction: 'asc' });
    const [error, setError] = useState("");
    const [selectedChecker, setSelectedChecker] = useState('');
    let csrfToken = sessionStorage.getItem("tokenizedSession");

    // const userIds = ["U001", "U002", "U003"];

    // const userNames = ["Vasanth", "Rahul", "Kiran"];

    // const departments = [
    //     "Finance",
    //     "Risk Management",
    //     "Compliance",
    //     "Audit"
    // ];

    const dept = sessionStorage.getItem("dept");

    const roles = [
        "CRO",
        "Risk Officer",
        "Department Head"
    ];

    useEffect(() => {
        // clear departments whenever role changes
        setSelectedDepartments([]);
    }, [selectedRole]);

    const fetchDepartments = async () => {
        try {
            setIsLoading(true);
            const config = {
                params: { "adminId": localStorage.getItem('userid'), ownership: "Y" },
                headers: {
                    'x-csrf-token': csrfToken,
                },
                withCredentials: true
            }
            const response = await axios.post(OwnershipApi, {}, config);
            console.log("Ownership API Response:", response.data);

            // ✅ Extract Ownership array
            const ownershipList = response.data?.Ownership || [];
            console.log("Fetched Ownership List:", ownershipList);

            setDepartments(ownershipList);

        } catch (error) {
            console.error("Error fetching departments:", error);
            setDepartments([]);
        }
    };

    useEffect(() => {
        fetchDepartments();
    }, []);

    // useEffect(() => {
    //     const fetchUsers = async () => {
    //         try {
    //             setIsLoading(true);
    //             const config = {
    //                 params: { "adminId": localStorage.getItem('userid') },
    //                 headers: {
    //                     'x-csrf-token': csrfToken,
    //                 },
    //                 withCredentials: true
    //             }
    //             const response = await axios.post(ListAllusers, {}, config);

    //             setUsers(response.data.users);
    //             setFilteredUsers(response.data.users);
    //             setIsLoading(false);
    //         } catch (error) {
    //             console.error('There was an error fetching the users!', error);
    //             setIsLoading(false);
    //         }
    //     };
    //     fetchUsers();
    // }, []);

    useEffect(() => {
        const fetchUsersData = async () => {
            try {
                setIsLoading(true);

                const config = {
                    params: { adminId: localStorage.getItem('userid') },
                    headers: { 'x-csrf-token': csrfToken },
                    withCredentials: true
                };

                // Parallel API calls
                const [allUsersRes, mappedUsersRes] = await Promise.all([
                    axios.post(ListAllusers, {}, config),
                    axios.post(RoleandMapping, {}, {
                        ...config,
                        params: {
                            ...config.params,
                            tableName: "user_role_mapping"
                        }
                    })
                ]);

                const allUsers = allUsersRes.data.users || [];

                const mappedUserIds = new Set(
                    (mappedUsersRes.data.data || []).map(item => String(item.USERID))
                );

                // FILTER: remove mapped users
                const filtered = allUsers.filter(
                    user => !mappedUserIds.has(String(user.userId))
                );

                setUsers(filtered);
                setFilteredUsers(filtered);

            } catch (error) {
                console.error("Error fetching users!", error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchUsersData();
    }, []);

    const handleUserSelect = (e) => {
        const selectedId = e.target.value;

        const selectedUser = users.find(
            (user) => user.userId === selectedId
        );

        setFormData((prev) => ({
            ...prev,
            searchUserId: selectedId,
            userFirstName: selectedUser?.userFirstName || ""
        }));
    };

    const handleCancelUpload = () => {
        setShowAllowUploadPopup(false);
        setPendingPayload(null);
    };

    const handleForceUpload = async () => {
        try {
            setShowAllowUploadPopup(false);
            setIsLoading(true);

            const responseDb = await submitLdapData('Y'); // second call

            if (responseDb.data?.status === 'success') {
                setMessageType('success');
                setModalMessage(responseDb.data?.message);
            } else {
                setMessageType('error');
                setModalMessage(responseDb.data?.message || "Update failed");
            }

        } catch (error) {
            console.error(error);
            setMessageType('error');
            setModalMessage('Error while updating');
        } finally {
            setIsLoading(false);
            setPendingPayload(null);
        }
    };

    const submitLdapData = async (allowUpdate = '') => {
        const adminId = localStorage.getItem('userid') || '';

        const jsonData = {
            userId: formData.searchUserId,
            userName: formData.userFirstName,
            role: selectedRole,
            departments: selectedDepartments,
            adminId: adminId
        };

        const content = JSON.stringify(jsonData, null, 2);
        const filename = `${adminId}_config.json`;

        // Step 1: Save file
        await axios.post(
            createTextFileApi,
            { filename, content },
            {
                headers: {
                    'Content-Type': 'application/json',
                    userId: adminId,
                    'x-csrf-token': csrfToken,
                },
                withCredentials: true,
            }
        );

        // Step 2: Call API
        const config = {
            headers: {
                userId: adminId,
                "x-csrf-token": csrfToken
            },
            withCredentials: true,
            params: {
                filePath: `/saswork/nas/${filename}`,
                Notifications: "IN",
                dept: dept,
                allowUpdate: allowUpdate   //  dynamic
            }
        };

        return await axios.post(mappingdata, {}, config);
    };

    const handleLdapSubmit = async (e) => {
        e.preventDefault();

        try {
            const adminId = localStorage.getItem('userid') || '';

            // Validation
            if (!formData.searchUserId) {
                setMessageType('error');
                setModalMessage("User Id is required");
                return;
            }

            if (!formData.userFirstName) {
                setMessageType('error');
                setModalMessage("User Name is required");
                return;
            }

            if (!selectedRole) {
                setMessageType('error');
                setModalMessage("Role is required");
                return;
            }

            if (selectedDepartments.length === 0) {
                setMessageType('error');
                setModalMessage("Department is required");
                return;
            }

            setIsLoading(true);

            const responseDb = await submitLdapData(); // first call

            if (responseDb.data?.status?.toLowerCase() === 'update') {

                // store state for retry
                setPendingPayload(true);

                setModalMessage3(`
                ${formData.searchUserId} is already mapped to ${responseDb.data.userRole} role.<br/>
                Existing Department: ${responseDb.data.existingDepartment}<br/>
                Do you want to update?
            `);

                setShowAllowUploadPopup(true);
                return;
            }

            if (responseDb.data?.status === 'success') {
                setMessageType('success');
                setModalMessage(responseDb.data?.message);
            } else {
                setMessageType('error');
                setModalMessage(responseDb.data?.message || "Failed");
            }

        } catch (error) {
            console.error(error);
            setMessageType('error');
            setModalMessage('Error while processing request');
        } finally {
            setIsLoading(false);
        }
    };


    const handleClear = () => {
        setShowModalLdap(false);

        setFormData({
            searchUserId: "",
            userFirstName: "",
            userRole: "",
            orgHierarchy: ""
        });

        setSelectedRole("");           //  FIX
        setSelectedDepartments([]);    //  FIX

        setInitialData({});
        setEditIndex(null);
        setMessage('');
    };

    const handleCloseLdap = () => {

        if (messageType === 'error') {
            setModalMessage('');
            return;
        }
        setShowModalLdap(false);

        setFormData({
            searchUserId: "",
            userFirstName: "",
            userRole: "",
            orgHierarchy: ""
        });

        setModalMessage('');
        setSelectedRole("");           //  FIX
        setSelectedDepartments([]);    //  FIX

        setInitialData({});
        setEditIndex(null);
        setMessage('');
    };

    const handleDashboard = (e) => {
        e.preventDefault();
        navigate('/gapsyAdashboard');
        // Additional logic if needed
    };

    const handleRaf = (e) => {
        e.preventDefault();
        navigate('/gapsyuserroleandmapping');
        // Additional logic if needed
    };

    const handleCloseModal = () => {
        setModalMessage('');
    };

    return (
        <div className={`d-flex flex-column min-vh-100 ${styles.pageFullBackground}`}>
            <Header />
            <Navigation />
            <div className="top-0 px-4 py-2 text-white">
                <div className="d-flex justify-content-between align-items-center flex-wrap">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-1">
                                <li className="breadcrumb-item">
                                    <a onClick={handleDashboard} className={`text-info ${styles.textInfo}`} style={{ textDecoration: 'none' }}>
                                        <i className="bi bi-house me-2" style={{ cursor: "pointer" }}></i>/
                                    </a>
                                </li>
                                <li className={`breadcrumb-item ${styles.breadcrumbItem}`} style={{ cursor: "pointer" }} aria-current="page">
                                    <a onClick={handleRaf} className={`text-info ${styles.textInfo}`} style={{ textDecoration: 'none' }}>
                                        <i className="bi bi-person-plus me-2" ></i>RAF - User - Role Mapping
                                    </a>
                                </li>
                                {/* <li className={`breadcrumb-item ${styles.breadcrumbItem}`} aria-current="page">
                                    <i onClick={handleRaf} className="bi bi-person-plus me-2"></i>RAF - User - Role Mapping
                                </li> */}
                                <li className={`breadcrumb-item active ${styles.breadcrumbItem}`} aria-current="page">
                                    <i className="bi bi-person-plus me-2"></i>RAF - Add New User - Role Mapping
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            <main className="flex-grow-1 container-fluid">
                <div className={styles.mainContainer}>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-12 col-md-12">
                                <div className='row'>
                                    <div className="col justify-content-center">
                                        <div className={`card h-100 ${styles.cardBorder} ${styles.card}`}>
                                            <div className="card-body">
                                                <div className="mb-0">
                                                    <h6 className={`pb-1 mb-3 ${styles.borderBottom}`}>RAF - Add New User - Role Mapping</h6>
                                                    <div className="d-flex justify-content-center">
                                                        <div className="w-100" style={{ maxWidth: '700px' }}>
                                                            <div className={`mx-auto ${formStyles.formWrapper}`}>



                                                                {/* {isLoading && (
                                                                    <>
                                                                        <div style={{
                                                                            position: 'absolute',
                                                                            top: 0,
                                                                            left: 0,
                                                                            right: 0,
                                                                            bottom: 0,
                                                                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                                                            zIndex: 1040
                                                                        }} />
                                                                        <div style={{
                                                                            position: 'absolute',
                                                                            top: '50%',
                                                                            left: '50%',
                                                                            transform: 'translate(-50%, -50%)',
                                                                            zIndex: 1050
                                                                        }}>
                                                                            <div className="spinner-border text-dark" role="status">
                                                                                <span className="visually-hidden">Loading...</span>
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                )} */}


                                                                <form className="form px-5" onSubmit={handleLdapSubmit}>

                                                                    <input type="hidden" name="adminId" value={localStorage.getItem('userid')} readOnly />

                                                                    {/* USER ID */}

                                                                    <div className="form-group row mb-2">
                                                                        <label className="col-sm-4 col-form-label label-black">
                                                                            Select User ID
                                                                        </label>

                                                                        <div className="col-sm-7">

                                                                            <select
                                                                                className="form-control form-control-sm"
                                                                                value={formData.searchUserId || ""}
                                                                                onChange={handleUserSelect}
                                                                            >
                                                                                <option value="">Select User ID</option>

                                                                                {users.map((user) => (
                                                                                    <option key={user.userId} value={user.userId}>
                                                                                        {user.userId}
                                                                                    </option>
                                                                                ))}

                                                                            </select>

                                                                        </div>
                                                                    </div>

                                                                    {/* USER NAME */}

                                                                    <div className="form-group row mb-2">
                                                                        <label className="col-sm-4 col-form-label label-black">
                                                                            User Name
                                                                        </label>

                                                                        <div className="col-sm-7">

                                                                            <input
                                                                                type="text"
                                                                                className="form-control form-control-sm"
                                                                                value={formData.userFirstName || ""}
                                                                                readOnly
                                                                            />

                                                                        </div>
                                                                    </div>

                                                                    {/* ROLE SINGLE SELECT */}

                                                                    <div className="form-group row mb-2">
                                                                        <label className="col-sm-4 col-form-label label-black">
                                                                            Select Role
                                                                        </label>

                                                                        <div className="col-sm-7">

                                                                            <select
                                                                                className="form-control form-control-sm"
                                                                                value={selectedRole || ""}
                                                                                onChange={(e) => setSelectedRole(e.target.value)}
                                                                            >
                                                                                <option value="">Select Role</option>

                                                                                {roles.map((role, index) => (
                                                                                    <option key={index} value={role}>
                                                                                        {role}
                                                                                    </option>
                                                                                ))}

                                                                            </select>

                                                                        </div>
                                                                    </div>
                                                                    {/* DEPARTMENT MULTI SELECT */}

                                                                    <div className="form-group row mb-2">

                                                                        <label className="col-sm-4 col-form-label label-black">Select RAF Department</label>

                                                                        <div className="col-sm-7">

                                                                            <div className="dropdown">

                                                                                <button
                                                                                    className="btn btn-light btn-sm dropdown-toggle w-100 text-start text-truncate"
                                                                                    type="button"
                                                                                    data-bs-toggle="dropdown"
                                                                                    style={{ overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}
                                                                                >
                                                                                    {selectedDepartments.length > 0
                                                                                        ? selectedDepartments.join(", ")
                                                                                        : "Select Department"}
                                                                                </button>

                                                                               <ul
                                                                                    className="dropdown-menu w-100"
                                                                                    style={{ maxHeight: "200px", overflowY: "auto" }}
                                                                                >

                                                                                    {departments.map((dept, index) => (

                                                                                        <li key={index} className="px-2">

                                                                                            <div className="form-check">

                                                                                                <input
                                                                                                    type="checkbox"
                                                                                                    className="form-check-input"
                                                                                                    checked={selectedDepartments.includes(dept)}
                                                                                                    onChange={(e) => {
                                                                                                        const isDeptHead = selectedRole === "Department Head";

                                                                                                        if (e.target.checked) {

                                                                                                            if (isDeptHead) {
                                                                                                                //  allow only one selection (replace existing)
                                                                                                                setSelectedDepartments([dept]);
                                                                                                            } else {
                                                                                                                //   multi-select
                                                                                                                setSelectedDepartments([...selectedDepartments, dept]);
                                                                                                            }

                                                                                                        } else {
                                                                                                            // uncheck works normally
                                                                                                            setSelectedDepartments(
                                                                                                                selectedDepartments.filter(d => d !== dept)
                                                                                                            );
                                                                                                        }
                                                                                                    }}
                                                                                                />

                                                                                                <label className="form-check-label">{dept}</label>

                                                                                            </div>

                                                                                        </li>

                                                                                    ))}

                                                                                </ul>

                                                                            </div>

                                                                        </div>

                                                                    </div>


                                                                    {/* BUTTONS */}

                                                                    <div className="form-group row mt-2">

                                                                        <div className="col-sm-4"></div>

                                                                        <div className="col-sm-7 d-flex">

                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-sm btn-secondary me-2"
                                                                                onClick={handleClear}
                                                                                style={closeButtonStyle}
                                                                            >
                                                                                Clear
                                                                            </button>

                                                                            <button
                                                                                type="submit"
                                                                                className="btn btn-sm btn-primary"
                                                                                style={Saveandadduser}
                                                                                disabled={disableInputs}
                                                                            >
                                                                                Submit
                                                                            </button>

                                                                        </div>

                                                                    </div>

                                                                </form>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {showAllowUploadPopup && (
                                            <Modal show onHide={handleCancelUpload} backdrop="static" keyboard={false} style={{ marginTop: '12vh' }}>
                                                <Modal.Header style={{ backgroundColor: '#366872', color: 'white', padding: '0.5rem 1rem' }}>
                                                    <Modal.Title style={{ fontSize: '16px' }}>Confirmation</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body style={{ padding: '0.75rem 1rem', fontSize: '14px' }}
                                                    /* <sttong>{toTitleCase(editableTableName)}</sttong> Template is already exists. Do you wish to upload data with the same template? */
                                                    dangerouslySetInnerHTML={{
                                                        __html: modalMessage3.replace(/\n/g, '<br />')
                                                    }}>
                                                </Modal.Body>
                                                <Modal.Footer style={{ borderTop: 'none' }}>
                                                    <Button variant="secondary" onClick={handleCancelUpload}>No</Button>
                                                    <Button variant="primary" onClick={handleForceUpload}>Yes</Button>
                                                </Modal.Footer>
                                            </Modal>
                                        )}

                                        {/* Modal for messages */}
                                        <Modal
                                            show={!!modalMessage}
                                            onHide={handleCloseModal}
                                            backdrop="static"
                                            keyboard={false}
                                            style={{ marginTop: '12vh' }}
                                        >
                                            <div
                                                className={`alert alert-${messageType === 'success' ? 'success' : messageType === 'warning' ? 'warning' : 'danger'} alert-dismissible fade show`}
                                                role="alert"
                                                style={{ marginBottom: '0' }}
                                            >
                                                <div className="d-flex align-items-center">
                                                    {messageType === 'success' ? (
                                                        <span className="me-2" style={{ color: 'green', fontSize: '14px' }}>✅</span>
                                                    ) : messageType === 'warning' ? (
                                                        <span className="me-2" style={{ color: '#ffc107', fontSize: '14px' }}>⚠️</span>
                                                    ) : (
                                                        <span className="me-2" style={{ color: 'red', fontSize: '14px' }}>❌</span>
                                                    )}
                                                    <p
                                                        style={{
                                                            display: 'inline',
                                                            marginBottom: '0px',
                                                            color: messageType === 'success'
                                                                ? 'green'
                                                                : messageType === 'warning'
                                                                    ? '#ffc107'
                                                                    : 'red'
                                                        }}
                                                    >
                                                        {modalMessage}
                                                    </p>
                                                </div>
                                                <button
                                                    type="button"
                                                    className="btn-close"
                                                    onClick={handleCloseLdap}
                                                    style={{ width: '15px', height: '15px', fontSize: '8px', position: 'absolute', bottom: '10px', right: '10px' }}
                                                />
                                            </div>
                                        </Modal>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default GapsyUserMapping;
